module.exports = __webpack_public_path__ + "images/academia-moinhos-fitness.jpg?3a8837b92ace7e485b9cc3cf033c73d5";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/assets/images/fidelidade/academia-moinhos-fitness.jpg
// module id = 979
// module chunks = 0